import React, { useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TrainerLayout from './TrainerLayout';
import Tabs from '../commons/Tabs';
import { TrainerContext } from '../../context/TrainerContext';
import SchoolData from "./SchoolData";
import TrainersList from "./TrainersList";
import SchoolSettings from "./SchoolSettings";
import OfferedServices from "./OfferedServices";

const SchoolDetails = () => {
    const { t } = useTranslation(['school', 'common']);
    const { trainer } = useContext(TrainerContext);
    const [searchParams] = useSearchParams();
    const schoolId = trainer?.schoolId;
    const initialTab = searchParams.get('tab');

    if (!schoolId) {
        return <div>{t('common:loading')}</div>;
    }

    const tabs = [
        {
            key: 'dane-szkoly',
            label: t('school:tabs.schoolData'),
            endpoint: `/api/v1/school/${schoolId}`, // Used by Tabs for caching/pagination if needed
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <SchoolData schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'trenerzy',
            label: t('school:trainers'),
            endpoint: `/api/v1/trainer/find-all/${schoolId}`, // This is where we fetch trainers for the table
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <TrainersList schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'ustawienia',
            label: t('school:tabs.settings'),
            endpoint: `/api/v1/school/${schoolId}/settings`,
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <SchoolSettings schoolId={schoolId} />
                </div>
            ),
        },
        {
            key: 'uslugi',
            label: t('school:services'),
            endpoint: `/api/v1/services/school/${schoolId}`, // Optional: used for caching/pagination if needed
            paginated: false,
            renderContent: () => (
                <div style={{
                    padding: '24px'
                }}>
                    <OfferedServices schoolId={schoolId} />
                </div>
            ),
        },
    ];

    return (
        <TrainerLayout>
            <div style={{
                padding: '20px',
                boxSizing: 'border-box',
                backgroundColor: '#f9fafb',
                minHeight: '100vh'
            }}>


                <div style={{
                    overflow: 'hidden'
                }}>
                    <Tabs tabs={tabs} activeId={schoolId} initialTab={initialTab} />
                </div>
            </div>
        </TrainerLayout>
    );
};

export default SchoolDetails;